<template>
<!-- template for the modal component -->
<transition name="modal">
  <div class="modal-mask">
    
    <div class="modal-wrapper" style="height:95vh;">
      <div class="d-flex px-10 justfiy-space-between">
        <v-btn elevation="0" class="modal-default-button mb-5 ma-4" color="error" fab  @click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <v-progress-circular
      style="position:absolute;right:0"
      class="mb-5 ma-4"
      v-if="refreshing"
      :width="5"
      color="green"
      :size="50"
      indeterminate
    ></v-progress-circular>
    <v-btn elevation="0"    v-else class="modal-default-button mb-5 ma-4" color="success" fab  @click="refreshMeetings()">
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
      </div>
      <div class="modal-container text-center" style="width:95vw;padding:0px;margin:0 auto;height:80vh;">
        <v-card tile:color="color" elevation="0">
          <v-tabs background-color="#232D3F"
            dark>
            <v-tabs-slider color="#F54B88"></v-tabs-slider>
              
              <v-tab @click="setRaceFilterType('THOROUGHBRED')" class="font-weight-bold white--text">
                <MeetingIcon :meeting="{type:'THOROUGHBRED'}" class="raceIcon" :inverse="true"/>THOROUGHBRED
              </v-tab>
              <v-tab @click="setRaceFilterType('HARNESS')" class="font-weight-bold white--text">
                <MeetingIcon :meeting="{type:'HARNESS'}" class="raceIcon" :inverse="true"/>HARNESS
              </v-tab>
          </v-tabs>
          <v-tabs
            background-color="#232D3F"
            dark
          >
          <v-tabs-slider color="#F54B88"></v-tabs-slider>
           
            <v-tab class="font-weight-bold white--text">
              {{formatDate(todayDate)}}
            </v-tab>
            <v-tab class="font-weight-bold white--text">
              {{formatDate(tomorrowDate)}}
            </v-tab>
            <v-tab class="font-weight-bold white--text">
              {{formatDate(thirdDate)}}
            </v-tab>
            <v-tab-item>
              <v-card flat tile elevation="0">
                <v-list tile class="py-0 " >
                  <div class="meetingsContainer0 mt-5" style="height:calc(80vh - 96px); overflow-y: scroll">
                    <v-list-item v-show="meeting.type === raceTypeSetting" v-for="meeting in getDaysMeetings(meetingsDated, todayDate)" :key="meeting.id"  no-action style="border-bottom:1px solid #dadada">
                      <v-list-item-content>
                        <v-card elevation="0">
                          <v-list-item-title class="subtitle-1 font-weight-bold pt-1 d-flex align-center" style="text-align:left;"><CountryFlags class="d-inline mr-1" :meeting="meeting" :small="'normal'"/><span class="ml-2">{{meeting.track.country}} - {{ meeting.track.name }} </span></v-list-item-title>
                          <v-card v-for="race in sortRaces(meeting.races)" :key="race.id" class="float-left mr-2" elevation="0" >
                            <v-badge :color="raceBubbleColor(race.status)" dot overlap bordered><v-btn elevation="0" color="#465169" dark class="font-weight-bold mt-1 title" large @click="clickRace(meeting, race), $emit('close')">{{race.number}}</v-btn></v-badge>
                            <h5 class="pt-1">{{formatTime(race.startTime)}}</h5>
                          </v-card>
                        </v-card>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <div style="height:100px;width:100px;"></div>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-list>
              </v-card>
              <v-card v-if="!$vuetify.breakpoint.xl" color="primary" class="float-right pa-3 mt-n15" style="height:96px;position:absolute;right:0;z-index:201;">
                <v-btn elevation="0" class="float-left mr-3" width="110px" color="#465169" :small="!$vuetify.breakpoint.xl" dark @click="scrollTop('0')"><v-icon>mdi-chevron-up</v-icon></v-btn>
                <v-btn elevation="0" class="float-right" width="110px" color="#465169" :small="!$vuetify.breakpoint.xl" dark @click="scrollDown('0')"><v-icon>mdi-chevron-down</v-icon></v-btn>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat tile elevation="0">
                <v-list tile class="py-0">
                  <div class="meetingsContainer1" style="height:calc(80vh - 96px);overflow-y:scroll">
                    <v-list-item v-show="meeting.type === raceTypeSetting" v-for="meeting in getDaysMeetings(meetingsDated, tomorrowDate)" :key="meeting.id"  no-action style="border-bottom:1px solid #dadada">
                      <template>
                        <v-list-item-content>
                          <v-card elevation="0">
                            <v-list-item-title class="subtitle-1 font-weight-bold d-flex align-center" style="text-align:left;"><CountryFlags class="d-inline mr-1 " :meeting="meeting" :small="'normal'"/><span class="ml-2">{{meeting.track.country}} - {{ meeting.track.name }}</span></v-list-item-title>
                            <v-card v-for="race in sortRaces(meeting.races)" :key="race.id" class="float-left mr-2" elevation="0">
                              <v-badge :color="raceBubbleColor(race.status)" dot overlap bordered><v-btn elevation="0"  color="#465169" dark class="font-weight-bold mt-1 title" large @click="clickRace(meeting, race), $emit('close')">{{race.number}}</v-btn></v-badge>
                              <h5 class="pt-1">{{formatTime(race.startTime)}}</h5>
                            </v-card>
                          </v-card>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <div style="height:100px;width:100px;"></div>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-list>
              </v-card>
              <v-card  v-if="!$vuetify.breakpoint.xl" color="primary" class="float-right pa-3 mt-n15" style="height:96px;position:absolute;right:0;z-index:201;">
                <v-btn elevation="0" class="float-left mr-3" width="110px" color="#465169" :small="!$vuetify.breakpoint.xl" dark @click="scrollTop('1')"><v-icon>mdi-chevron-up</v-icon></v-btn>
                <v-btn elevation="0" class="float-right" width="110px" color="#465169" :small="!$vuetify.breakpoint.xl" dark @click="scrollDown('1')"><v-icon>mdi-chevron-down</v-icon></v-btn>
              </v-card>
            </v-tab-item>
            <v-tab-item >
              <v-card flat tile elevation="0">
                <v-list tile class="py-0" >
                  <div class="meetingsContainer2" style="height:calc(80vh - 96px);overflow-y:scroll">
                    <v-list-item v-show="meeting.type === raceTypeSetting" v-for="meeting in getDaysMeetings(meetingsDated, thirdDate)" :key="meeting.id"  no-action style="border-bottom:1px solid #dadada">
                      <template>
                        <v-list-item-content>
                          <v-card elevation="0">
                            <v-list-item-title class="subtitle-1 font-weight-bold d-flex align-center" style="text-align:left;"><CountryFlags class="d-inline mr-1" :meeting="meeting" :small="'normal'"/><span class="ml-2">{{meeting.track.country}} - {{ meeting.track.name }}</span></v-list-item-title>
                            <v-card v-for="race in sortRaces(meeting.races)" :key="race.id" class="float-left mr-2" elevation="0" >
                              <v-badge :color="raceBubbleColor(race.status)" dot overlap bordered><v-btn elevation="0" color="#465169"  dark class="font-weight-bold mt-1 title" large @click="clickRace(meeting, race), $emit('close')">{{race.number}}</v-btn></v-badge>
                              <h5 class="pt-1">{{formatTime(race.startTime)}}</h5>
                            </v-card>
                          </v-card>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <div style="height:100px;width:100px;"></div>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-list>
              </v-card>
              <v-card v-if="!$vuetify.breakpoint.xl" color="primary" class="float-right pa-3 mt-n15" style="height:96px;position:absolute;right:0;z-index:201;">
                <v-btn elevation="0" class="float-left mr-3" width="110px" color="#465169" :small="!$vuetify.breakpoint.xl" dark @click="scrollTop('2')"><v-icon>mdi-chevron-up</v-icon></v-btn>
                <v-btn elevation="0" class="float-right" width="110px" color="#465169" :small="!$vuetify.breakpoint.xl" dark @click="scrollDown('2')"><v-icon>mdi-chevron-down</v-icon></v-btn>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </div>
    </div>
  </div>
</transition>
</template>

<script>

</script>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import cloneDeep from 'clone-deep'
import CountryFlags from './CountryFlags'
import { format, isSameDay } from 'date-fns'
import MeetingIcon from './MeetingIcon'

export default {
  name: "MeetingNavigation",
  data() {
    return {
      color: 'primary',
      todayDate: moment().startOf('day').format(),
      tomorrowDate: moment().startOf('day').add(1,'d').format(),
      thirdDate: moment().startOf('day').add(2,'d').format(),
      timerMeetings: null,
      timerRaces: null,
      raceTypeSet: '',
      refreshing: false
    }
  },
  components: {
    CountryFlags,
    MeetingIcon
  },
  props: {
    meetingsDated: Array
  },
  beforeUpdate () {
    if (this.signedIn === false) {
    this.cancelAutoUpdate();
    }
    if (this.signedIn === true && !this.timerMeetings) {
    }
  },
  beforeDestroy () {
    clearInterval(this.timerRaces)
    clearInterval(this.timerMeetings)
  },
  computed: {
  ...mapState(['nextToGoRaces', 'signedIn']),
  ...mapGetters(['getMeetings']),
  meetings () {
    return this.getMeetings || []
  },
  raceTypeSetting () {
    if (this.raceTypeSet === '') {
      return 'THOROUGHBRED'
    }
    return this.raceTypeSet
  }
  },
  methods: {
    moment,
    ...mapActions(['selectMeeting', 'selectRace', 'loadRunners', 'mountNextToGo','fetchMeetings']),
    getDaysMeetings (meetings, date) {
      return meetings?.filter(m => ['THOROUGHBRED', 'HARNESS'].includes(m.type) && isSameDay(new Date(m.races?.[0]?.startTime || m.date), new Date(date))) || []
    },
    refreshMeetings() {
      this.fetchMeetings()
      this.refreshing = true
      setTimeout(() => {
        this.refreshing = false
      }, 3000);
      
    },
    setRaceFilterType(v) {
      this.raceTypeSet = v
    },
    scrollTop(v) {
      let content = document.querySelector(".meetingsContainer" + v)
      content.scrollTop -= 150
    },
    scrollDown(v) {
      let content = document.querySelector(".meetingsContainer" + v)
      content.scrollTop += 150
    },
    cancelAutoUpdate () { 
      clearInterval(this.timerRaces) 
      clearInterval(this.timerMeetings) 
      this.timerRaces = null, this.timerMeetings = null
    },
    async clickRace (meeting, race) {
      this.selectMeeting (meeting.id)
      //const nextToGoInMeeting = v.races.find(race => race.status === 'selling');
      this.selectRace (race.id)
      // this.loadRunners (race)
    },
    sortRaces(races) {
      const sortedRaces = cloneDeep(races)
      return sortedRaces.sort(function(a, b) {
        return a.number - b.number;
      });
    },
    getFilteredMeetings(filteredMeetings) {
      return filteredMeetings.filter(meeting => meeting.type === 'R')
    },
    getNtgFilteredMeetings(filteredNtgRaces) {
      return filteredNtgRaces.filter(race => race.type === 'R')
    },
    formatDate : function (date) {
      return moment(date, 'YYYY-MM-DD').format('LL');
    },
    formatTime : function (dateStr) {
      return format(new Date(dateStr),"p")
    },
    formatDateNtg : function (date) {
      return moment(date, 'YYYY-MM-DD HH:mm').fromNow('ss');
    },
    raceBubbleColor: function (raceStatus) {
        if (raceStatus === 'FINAL') {
        return '#000'
      } else if (raceStatus === 'OPEN') {
        return 'success'
      } else if (raceStatus === 'ABANDONED') {
        return 'red'
      } else if (raceStatus === 'CLOSED') {
        return '#000'
      } else if (raceStatus === 'INTERIM') {
        return 'warning'
      }
    },
  },

  
}
</script>

<style scoped>
  .drawerSpacer {
    background:#fff;
    height:1px;
    width:100%;
  }
  .raceIcon {
  transform: scale(0.7);
  }
  .drawerSet {
    max-height:88vh;
    overflow:scroll
  }
  </style>

